const crossModalIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
      <polygon fill="#36484F" points="14.749 6.707 13.334 5.293 10.042 8.586 6.749 5.293 5.334 6.707 8.627 10 5.334 13.293 6.749 14.707 10.042 11.415 13.334 14.707 14.749 13.293 11.456 10" transform="translate(-5 -5)"/>
    </svg>
`;

export default crossModalIcon;
